export default __webpack_public_path__ + "static/media/pause.876dbb8c.svg";